module.exports = __webpack_public_path__ + "static/media/303Knob.77b84eee.svg";